import React from 'react'
import styled from 'styled-components'
import DesktopNav from './DesktopNav'
import MobileNav from './MobileNav'
import { spacing } from '../../styles/Rythms'

const Navbar = ({ pathname, ...props }) => {
  const category = pathname.split('/')[1]

  return (
    <Nav>
      <DesktopNav category={category} />
      <MobileNav />
    </Nav>
  )
}

export default Navbar

const Nav = styled.div`
  z-index: 9;
  display: flex;
  flex-flow: column nowrap;
  padding-bottom: ${spacing['16']};
`
